import React from "react";

import Link from "next/link";

import Icon from "@ant-design/icons";
import { NumericFormat } from "react-number-format";

import { colorPalet } from "@/lib/colorPalet";
import { CurrencySymbol } from "@/lib/currencySymbol";
import { HexagonSvg } from "@/lib/hexagon";
import tickerNameFormat from "@/lib/tickerNameFormat";

import ImageWithErrorHandling from "../ImageWithErrorHandling/index";

const StockCard = ({ stocks }) => {
  return (
    <Link
      href={`/${stocks.ticker.toLowerCase()}/${stocks.exchangeShortName.toLowerCase()}`}
    >
      <div className="stock-card cursor-pointer" key={stocks.id}>
        <div className="stock-header">
          <div className="stock-ticker m-0">
            <ImageWithErrorHandling
              src={stocks?.image}
              alt={`Is ${stocks?.companyName} (${stocks?.ticker}) ${stocks?.isEtf ? "fund" : "stock"} a good buy?`}
              className="stock-image"
            />
            <span className="ticker-symbol">
              {tickerNameFormat(stocks.ticker)}
            </span>
          </div>
          <div className="score align-items-end m-0">
            <span>{stocks.newScore}</span>/100
            <Icon
              component={() => HexagonSvg(colorPalet, "1.5em", "15px", 150)}
              className="ml-4"
            />
          </div>
        </div>
        <div className="advance-search-name">{stocks.companyName}</div>
        <div className="box-footer">
          <p className="box-footer-value">
            {CurrencySymbol(stocks?.currency)}
            {
              <NumericFormat
                value={Number(stocks?.share_price?.toFixed(2))}
                displayType={"text"}
                thousandSeparator={true}
              />
            }
          </p>
          <img
            alt="sparkline"
            src={`${process.env.NEXT_PUBLIC_API_URL}/assets/${stocks?.id}.svg`}
            width={76}
            height={31}
            onError={(e) => e.target.remove()}
          />
        </div>
      </div>
    </Link>
  );
};

export default StockCard;
